const styles = (theme) => ({
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
  },
});

export default styles;
